import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { PesquisaHomeOffice } from '../models/pesquisa-home-office';
import {from} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PesquisaHomeOfficeService {

  url = 'https://j90n9icdsh.execute-api.us-east-1.amazonaws.com/v1/pesquisahomeoffice';

  // injetando o HttpClient
  constructor(private httpClient: HttpClient) { }

  // Headers
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'x-api-key': 'JYP7XU0207aX0oECED23177JjNMFOGW3Dzyifkth' })
  }

  // Obtem todas as Pesquisas
  getPesquisaHomeOffice(): Observable<PesquisaHomeOffice[]> {

    return this.httpClient.get<PesquisaHomeOffice[]>(this.url)
      .pipe(
        retry(2),
        catchError(this.handleError))
  }

  
  // Obtem por id
  getPesquisaHomeOfficeById(id: number): Observable<PesquisaHomeOffice> {
    return this.httpClient.get<PesquisaHomeOffice>(this.url + '/' + id)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  // Salva
  savePesquisaHomeOffice(pesquisa: PesquisaHomeOffice): Observable<PesquisaHomeOffice> {
    return this.httpClient.post<PesquisaHomeOffice>(this.url, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  // Atualiza
  updatePesquisaHomeOffice(pesquisa: PesquisaHomeOffice): Observable<PesquisaHomeOffice> {
    return this.httpClient.put<PesquisaHomeOffice>(this.url + '/' + pesquisa.id, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Deleta
  deletePesquisaHomeOffice(pesquisa: PesquisaHomeOffice) {
    return this.httpClient.delete<PesquisaHomeOffice>(this.url + '/' + pesquisa.id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Manipulação de erros
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;

    } else {

      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;

    }

    console.log(errorMessage);
    return throwError(errorMessage);

  };


}